import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white" data-testid="not-found">
      <div className="text-center max-w-lg px-6">
        <div className="font-heading text-7xl text-[#F97316] tracking-tight" style={{ fontWeight: 900 }}>404</div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-[#1A1A1A] mt-6 leading-tight" style={{ fontWeight: 900 }}>Page not found.</h1>
        <p className="mt-5 text-base text-[#2B2F33]/75 leading-relaxed">The page you&rsquo;re looking for doesn&rsquo;t exist. Let&rsquo;s get you back on track.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white text-sm font-bold uppercase tracking-wider px-7 py-4 transition-colors" data-testid="not-found-cta">
          Back home <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
